export const MUI_TAB= {
    SELECTED:{
        TAB_NAME_COLOR: "#BA2E5D",
        BACKGROUND_COLOR: "#fdf2f6",
        HOVER_COLOR: "#f5e8ed",
        INDICATOR_COLOR: "#BA2E5D",
    }

};

export const MUI_TOOLTIP = {
    TOOLTIP_BACKGROUND_COLOR: "#fff",
    TOOLTIP_COLOR: "#161616",
    TOOLTIP_BOX_SHADOW: "0 4px 24px 0 rgba(0,59,157,0.10), 0 1.5px 6px 0 rgba(0,0,0,0.08)",
    TOOLTIP_BORDER_RADIUS: 10,
    TOOLTIP_FONT_SIZE: 12,
    TOOLTIP_PADDING: "10px 16px",
    TOOLTIP_LETTER_SPACING: 0.1,
    TOOLTIP_FONT_FAMILY: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
};

/** Matches Track Application / CustomSelect dropdown hover & selection */
export const MUI_MENU_ITEM = {
    SELECTED:{
        BACKGROUND_COLOR: "#fdf2f6",
        COLOR: "#BA2E5D",
        HOVER_COLOR: "#fdf2f6",
    },
    UNSELECTED:{
        BACKGROUND_COLOR: "transparent",
        COLOR: "#000",
        HOVER_COLOR: "#fdf2f6",
    },
};
export const MUI_STEPPER = {
    CONNECTOR:{
        LINE_BACKGROUND_COLOR: "#e5e7eb",
        ACTIVE_LINE_COLOR: "#BA2E5D",
        COMPLETED_LINE_COLOR: "#BA2E5D",
    },
};